module.exports = __webpack_public_path__ + "static/media/icon-link-log-out.8dc91075.svg";